import { Middleware } from '@reduxjs/toolkit';
import { fetchToken, refreshAuthToken, userLoggedOut } from '../reducers/authInfoReducer';
import { fetchModules, resetModuleHashes } from '../reducers/modules-reducer';
import { clearConfigCache, invalidateModuleCache } from '../../services/configCacheService';
import {
  clearModuleHashes,
  getModuleHashes,
  setModuleHashes,
} from '../../services/moduleHashStorage';
import { ModuleInfoResponse } from '../../models/ModuleInfoResponse';

const RESET_CACHE_ACTIONS = new Set([
  refreshAuthToken.fulfilled,
  fetchToken.fulfilled,
  userLoggedOut.type,
]);

export const cacheInvalidationMiddleware: Middleware =
  ({ dispatch }) =>
  (next) =>
  (action) => {
    const result = next(action);

    if (RESET_CACHE_ACTIONS.has(action.type)) {
      clearConfigCache();
      clearModuleHashes();
      dispatch(resetModuleHashes());
    }

    if (fetchModules.fulfilled.match(action)) {
      const modules: ModuleInfoResponse[] = action.payload;
      const savedHashes = getModuleHashes();
      const newHashes: Record<string, string> = {};

      for (const mod of modules) {
        if (mod.hash) {
          const moduleKey = mod.classifier || mod.name;
          newHashes[moduleKey] = mod.hash;

          if (savedHashes[moduleKey] !== mod.hash) {
            invalidateModuleCache(moduleKey);
          }
        }
      }

      for (const moduleName of Object.keys(savedHashes)) {
        if (!newHashes[moduleName]) {
          invalidateModuleCache(moduleName);
        }
      }

      setModuleHashes(newHashes);
    }

    return result;
  };
